import gql from 'graphql-tag';
import { financialApplicationFragment } from './fragments';

export const financialApplications = gql`
  query financialApplications($where: FinancialApplicationWhereInput, $orderBy: FinancialApplicationOrderByInput, $skip: Int, $after: String, $before: String, $first: Int, $last: Int) {
    financialApplications(where: $where, orderBy: $orderBy, skip: $skip, after: $after, before: $before, first: $first, last: $last) ${financialApplicationFragment}
  }
`;
